import 'select2/dist/js/select2.full.js'

jQuery('.activity__select select').select2({
    width: '100%'
}).on('change', function () {
    window.location = jQuery(this).val()
})

jQuery('.pfts select').select2({
    width: '100%'
}).on('change', function () {
    window.location = jQuery(this).val()
})

jQuery('.nav-dropdown select').select2({
    width: '100%',
}).on('change', function () {
    window.location = jQuery(this).val()
})

jQuery('.gform_wrapper .ginput_container_select select').select2({
    width: '100%',
})

jQuery('.form select').select2({
    width: '100%',
})

jQuery(document).on('gform_post_render', function(){

    jQuery('.gform_wrapper .ginput_container_select select').select2('destroy').select2({ width: '100%' })

});

jQuery('.score__select #score_age, .score__select #score_gender, .score__select #score_skill, .score__select #score_type').select2({
    width: '98%'
})

jQuery('.nav-dropdown-scores select').select2({ width: '100%' });
